export default __webpack_public_path__ + "static/leading-is-purpose-2aa4fb81a6e67f9329211d0e276c0d17.svg";